<template>
    <b-row v-if="getUserRelatedRecentSitesBySemester">
        <b-col
            cols="12"
            lg="10"
            offset-lg="1"
        >
            <b-jumbotron class="py-5">
                <div>
                    <h3>Tus Asignaturas</h3>
                    <b-list-group
                        v-for="semester in getUserRelatedRecentSitesBySemester"
                        :key="semester.academicPeriod"
                    >
                        <h3>
                            <span class="lead">{{ semester.academicPeriod }}</span>
                        </h3>
                        <b-list-group-item
                            v-for="site in semester.sites"
                            :key="`site-${site.id}`"
                            class="clickable"
                            :to="{ name: 'site', params: { courseCode: site.course.code, academicPeriod: semester.academicPeriod }}"
                        >
                            <h4>
                                [{{ site.course.code }}] {{site.course.name}}
                                <small>
                                    <b-badge
                                        v-if="site.role === userRoles.coordinator"
                                        variant="success"
                                        class="ml-3 p-2"
                                    >
                                        Coordinador
                                    </b-badge>
                                </small>
                                <small>
                                    <b-badge
                                        v-if="site.role === userRoles.studentTeacher"
                                        variant="light"
                                        class="ml-3 p-2"
                                    >
                                        Preparador
                                    </b-badge>
                                </small>
                            </h4>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </b-jumbotron>
        </b-col>
    </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    name: 'HomeRecentRelatedSites',
    computed: {
        ...mapState([
            'userRoles'
        ]),
        ...mapGetters([
            'getUserRelatedRecentSitesBySemester'
        ])
    },
    methods: mapActions(['setHomeActiveCareer'])
}
</script>
